import { observer } from "mobx-react"
import { useUnregisteredBeaconStore } from "contexts/RootStore.context"
import ShowMoreButton from "components/DataTable/components/ShowMoreButton"
import { Column, DataTable } from "components/DataTable/DataTable";
import { UnregisteredBeacon } from "types/beacon";
import { useMemo, useState } from "react";
import { Box, Vertical } from "gls";
import { headerStyle } from "styling/App.style";
import NewBeaconSearch from "./NewBeaconSearch";
import { CheckBox } from "components/inputs/CheckBox/CheckBox";
import { clone } from "lodash";
import { ImportNewBeacons } from "./ImportNewBeacons";
import { style } from "typestyle";

export const NewBeaconsList = observer(() => {

  const {
    setSearchTerm,
    beaconList,
    loading,
    getEmptyListMsg,
    nextCount,
    loadUnregisteredBeacons,
  } = useUnregisteredBeaconStore()

  const [selectedBeacons, setSelectedBeacons] = useState<Set<string>>(new Set([]))

  const newBeaconColumns: Column<UnregisteredBeacon>[] = useMemo(() => {
    return [
      {
        title: <CheckBox
          checked={selectedBeacons.size === beaconList.length}
          value={1}
          name={`select-all`}
          id={`select-all`}
          onChange={(e) => {
            e.stopPropagation();
            if (e.target.checked)
              setSelectedBeacons(new Set(beaconList.map(r => r.beacon_id)))
            else
              setSelectedBeacons(new Set([]))
          }}
        />,
        noSort: true,
        field: "beacon_id",
        renderer: (cellValue: any) =>
          <CheckBox
            checked={selectedBeacons.has(cellValue)}
            value={cellValue}
            id={`new-beacon-${cellValue}`}
            name={`new-beacon-${cellValue}`}
            onChange={(e) => {
              e.stopPropagation();
              const newList = clone(selectedBeacons)
              if (newList.has(cellValue))
                newList.delete(cellValue)
              else
                newList.add(cellValue)

              setSelectedBeacons(newList);
            }}
          />
      },
      { title: 'BEACON ID', field: "beacon_id", noSort: true, defaultValue: "--" },
      { title: 'BEACON TYPE', field: "beacon_type", noSort: true, defaultValue: "--" },
      { title: 'NOTES', field: "notes", noSort: true, defaultValue: "--" },
      { title: 'MANAGER', field: "manager_id", noSort: true, defaultValue: "--" },
      { title: 'ORDER ID', field: "order_id", noSort: true, defaultValue: "--" },
      { title: 'SOURCE', field: "source", noSort: true, defaultValue: "--" },
      { title: 'VENUE', field: "", noSort: true, defaultValue: "--" },
    ]
  }, [beaconList, selectedBeacons])

  const onSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm)
    return loadUnregisteredBeacons(true)
  }

  return (
    <Vertical spacing={0} sizing={"stretch"} className={style({ overflow: "hidden" })}>
      <Box className={headerStyle}>
        <NewBeaconSearch onSearch={onSearch} />
      </Box>
      <DataTable<UnregisteredBeacon>
        loading={loading}
        columns={newBeaconColumns}
        data={beaconList}
        emptyListMsg={getEmptyListMsg}
        renderLoadMore={nextCount > 0 && (
          <ShowMoreButton
            fetchFunction={() => loadUnregisteredBeacons()}
            nextIsLoading={loading}
            nextCount={nextCount}
          />
        )}
      />

      {selectedBeacons.size > 0 &&
        <ImportNewBeacons
          onClose={() => setSelectedBeacons(new Set([]))}
          selectedBeacons={selectedBeacons}
        />
      }

    </Vertical>
  )
})